module.exports = __webpack_public_path__ + "img/fraude_four.df59b134.png";